// Browser autofill (saved phone / email / address suggestions) ko poore app me
// band karta hai, taaki data-entry forms me customer ki jagah apni saved details
// galti se na bhar jaayein.
//
// Chrome address/contact autofill ke liye autocomplete="off" ko ignore karta hai
// (isliye kai forms me laga "off" kaam nahi kar raha tha, aur MUI Autocomplete
// khud "off" bhejta hai phir bhi State dropdown me suggestions aa rahe the).
// "new-password" ek aisa token hai jis par Chrome saved values suggest nahi
// karta — MUI docs bhi yahi workaround batate hain.
//
// Har form me prop lagane ki jagah ek MutationObserver har naye input/textarea
// par ye attribute set kar deta hai. React sirf tab attribute dobara likhta hai
// jab uska prop badle, isliye ye override tikta hai.

const SKIP_TYPES = new Set([
  "password",
  "hidden",
  "checkbox",
  "radio",
  "file",
  "submit",
  "button",
  "reset",
  "image",
  "range",
  "color",
]);

const shouldDisable = (el) => {
  if (el.tagName === "INPUT" && SKIP_TYPES.has((el.type || "").toLowerCase())) return false;
  // Login / change-password jaise forms me browser ka password manager chalne do.
  if (el.form && el.form.querySelector('input[type="password"]')) return false;
  // Kisi field ko autofill chahiye to: <input data-allow-autofill ... />
  if (el.hasAttribute("data-allow-autofill")) return false;
  return true;
};

const apply = (el) => {
  if (shouldDisable(el) && el.getAttribute("autocomplete") !== "new-password") {
    el.setAttribute("autocomplete", "new-password");
  }
};

const applyWithin = (node) => {
  if (node.nodeType !== Node.ELEMENT_NODE) return;
  if (node.matches("input, textarea")) apply(node);
  node.querySelectorAll("input, textarea").forEach(apply);
};

export function installAutofillBlocker() {
  if (typeof document === "undefined" || typeof MutationObserver === "undefined") return;

  applyWithin(document.body);
  new MutationObserver((mutations) => {
    for (const m of mutations) m.addedNodes.forEach(applyWithin);
  }).observe(document.body, { childList: true, subtree: true });
}
